import {createFileRoute, redirect} from '@tanstack/react-router';

/** Legacy redirect: /profile/lists/:listId → /dashboard/lists/:listId. */
export const Route = createFileRoute('/profile/lists/$listId/')({
  beforeLoad: ({params}) => {
    throw redirect({
      to: '/dashboard/lists/$listId',
      params: {listId: params.listId},
      search: {page: 1, pageSize: 12},
    });
  },
});
